import Cookies from 'js-cookie';

const cookieName = 'cookies-accepted';

/**
 * Check if cookies are enabled in the browser
 * @returns {Boolean}
 */
export function cookiesEnabled() {
  let cookieEnabled = Boolean(window.navigator.cookieEnabled);

  if (!cookieEnabled) {
    document.cookie = 'cookieTest';
    cookieEnabled = Boolean(document.cookie.indexOf('cookieTest') !== -1);
  }

  return cookieEnabled;
}

/**
 * @returns {Boolean}
 */
export function cookiesAccepted() {
  const cookie = Cookies.get(cookieName);

  if (!cookie) {
    return false;
  }

  return true;
}

/**
 * @param {String} name
 * @returns {*} $.fn.Cookies instance
 */
export function createCookie(name = cookieName) {
  return Cookies.set(name, 1, {
    expires: 30,
  });
}
